export const sideNavBarWidth = 260
export const contentPaddingX = 45
export const breakPoints = {
  small: 480,
  medium: 768,
  large: 992,
}
